import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from "react-progressive-image";
import assets from "../../../../../../util/assets";
import ProfileTabComponent from "../tab";
import {Col, Collapse, Container} from "reactstrap";
import {getStatus, isEmpty} from "../../../../../../util/utility";
import "./index.css"
import ButtonWithImage from "../../../../../ButtonWithImage";
import TipModal from "../../../../../modal/TipModal";
import TipResponseModal from "../../../../../modal/TipResponseModal";
import ButtonDesign from "../../../../../ButtonDesign";
import {getData, LOGIN} from "../../../../../../util/storage";
import constants from "../../../../../../util/constants";
import api from "../../../../../../util/clipstore/user/subscription_api";
import follow_unfollow_api from "../../../../../../util/clipstore/user/follow_unfollow_api";

BroadcasterProfileHeader.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    pageName: PropTypes.string.isRequired,
    contentList: PropTypes.array.isRequired,
    activeTab: PropTypes.string.isRequired,
    payload: PropTypes.object,
    toggle: PropTypes.func.isRequired,
    showLogin: PropTypes.func.isRequired,
    isFollowing:PropTypes.bool
};

const hasSummary = (props) => {
    return (
        props.payload &&
        props.payload.hasOwnProperty("summary") &&
        props.payload.summary &&
        props.payload.summary.hasOwnProperty("followers")
    )
}

const hasBroadcasterObj = (props) => {
    return (props.payload &&
        props.payload.hasOwnProperty("summary") &&
        props.payload.summary &&
        props.payload.summary.hasOwnProperty("broadcaster") &&
        props.payload.summary.broadcaster &&
        props.payload.summary.broadcaster.hasOwnProperty("channel_image_rectangle"))
}

const checkIfSubscribed = (props) => {
    if (props.payload.summary.is_subscribed) {
        return "SUBSCRIBED";
    } else {
        return "SUBSCRIBE";
    }
}

const checkIfFollowing = (props) => {
    if(props.payload.summary.is_following || props.isFollowing){
        return "FOLLOWING";
    }else{
        return "FOLLOW";
    }
}

const getFollowingImageSrc = (props)=>{
    if(props.following.isFetching){
        return assets.loading_white
    }else if(checkIfFollowing(props) === "FOLLOW"){
        return assets.broadcaster.profile.follow_inactive;
    }else{
        return assets.broadcaster.profile.follow_active
    }
}

const getSubscribeImageSrc = (props)=>{
    if(props.purchase_content.isFetching){
        return assets.loading_white
    }else if(checkIfFollowing(props) === "SUBSCRIBE"){
        return assets.broadcaster.profile.subscribe_inactive;
    }else{
        return assets.broadcaster.profile.subscribe_inactive
    }

}

const showUserProfile = () => {
    let modal = document.getElementById("user-profile-modal");
    modal.classList.add("show");
    modal.style.display = "block";
    document.getElementsByClassName("modal-overlay")[0].style.display = "block"
};


const getChannelImage = (props) => {
    if (hasBroadcasterObj(props)) {
        return props.payload.summary.broadcaster.channel_image_rectangle;
    }

    return assets.channelImageBg;
}

const getProfileImage = (props)=>{
    if (hasBroadcasterObj(props)) {
        return props.payload.summary.broadcaster.profile_pic;
    }

    return assets.user_placeholder;
}

const hasBroadcasterID = (props)=>{
    return (
        props.contentList && Array.isArray(props.contentList) && props.contentList.length > 0 &&
        props.contentList[0].hasOwnProperty("broadcaster") &&
        props.contentList[0].broadcaster &&
        props.contentList[0].broadcaster.hasOwnProperty("id")
    )
}
function BroadcasterProfileHeader(props) {

    return (
        <Collapse isOpen={props.pageName === constants.BROADCASTER_PROFILE}>

            <Col sm="12"
                 className="bg-white p-3 mb-3 rounded"
                 style={{marginTop: 24, overflow: 'hidden'}}>

                <div className="top-card-channel-image relative"
                     style={{height: 181, overflow: 'hidden'}}>

                    <div tabIndex="0"
                         id="ember2683"
                         className="channel-image--no-rounded-corners channel-image ember-view">

                        <ProgressiveImage
                            delay={1000}
                            src={getChannelImage(props)}
                            placeholder="placeholder">

                            {(src, loading) => {
                                return loading ? (
                                        <img className="channel-image__image relative full-width"
                                             id="channel-image-target-image"
                                             alt="Background Image"
                                             src={assets.channelImageBg}/>
                                    ) :
                                    (
                                        <div className="channel-image__image relative full-width"
                                             id="channel-image-target-image"
                                             style={{
                                                 height: 181,
                                                 backgroundSize: 'cover',
                                                 backgroundImage: "linear-gradient(to bottom, rgba(26, 26, 26, 0.32), rgba(41, 41, 41, 0.53)),url('" + getChannelImage(props) + "')"
                                             }}>
                                        </div>
                                    )

                            }}
                        </ProgressiveImage>
                    </div>
                </div>

                <ProgressiveImage
                    delay={1000}
                    src={getProfileImage(props)}
                    placeholder="placeholder">

                    {(src, loading) => {
                        return loading ? (
                                <img alt="broadcaster profile picture"
                                     className="broadcaster-profile-container-user-section-profile-pic"
                                     src={assets.user_placeholder}/>
                            ) :
                            (
                                <div
                                    className="broadcaster-profile-container-user-section-profile-pic"
                                    style={{backgroundImage: "url('" + getProfileImage(props) + "')"}}>

                                    {
                                        hasBroadcasterObj(props) &&
                                        <img
                                            src={props.payload.summary.broadcaster.is_verified === 1 ? assets.clipstore.home.broadcaster_verified : assets.clipstore.home.broadcaster_unverified}
                                            alt="verified broadcaster"/>
                                    }
                                </div>
                            )

                    }}
                </ProgressiveImage>

                {
                    hasBroadcasterObj(props) &&
                    <div className="broadcaster-profile-container-broadcaster-details">
                        <Container>
                            <div className="display-flex-flex-direction-row-no-margin">
                                <div>
                                    <div className="broadcaster-profile-container-broadcaster-name">
                                        <span>{props.payload.summary.broadcaster.username}</span>
                                        <img src={getStatus(props.payload.summary.broadcaster.status)}
                                             className="broadcaster-profile-status-img"
                                             alt="broadcaster status"/>
                                    </div>
                                    <div>
                                    <span
                                        onClick={() => {
                                            //props.toggle("followers")
                                        }}
                                        className="broadcaster-profile-container-broadcaster-other-details">{`${props.payload.summary.followers} Followers`}</span>
                                        <span
                                            onClick={() => {
                                                props.isBroadcastersOwnPage && props.toggle("subscribers")
                                            }}
                                            className="broadcaster-profile-container-broadcaster-other-details">{`${props.payload.summary.subscribers} Subscribers`} </span>
                                        <span
                                            onClick={() => {
                                                props.toggle("published_content")
                                                props.filterApplied(null,"Video",null)
                                            }}
                                            className="broadcaster-profile-container-broadcaster-other-details">{`${props.payload.summary.videos} Videos`} </span>
                                        <span
                                            onClick={() => {
                                                props.toggle("published_content")
                                                props.filterApplied(null,"Picture",null)
                                            }}
                                            className="broadcaster-profile-container-broadcaster-other-details">{`${props.payload.summary.pictures} Pictures`} </span>
                                    </div>
                                </div>

                                <Collapse isOpen={props.isBroadcastersOwnPage}>
                                    <ButtonDesign
                                        btName={"EDIT PROFILE"}
                                        btColor="link"
                                        btClass="text-decoration-none bg-white rounded-0 followbtn btn-with-shadow"
                                        onclickFunction={showUserProfile}/>
                                </Collapse>

                                <Collapse isOpen={!props.isBroadcastersOwnPage}>
                                    <ButtonWithImage
                                        color={"secondary"}
                                        text={checkIfSubscribed(props)}
                                        src={getSubscribeImageSrc(props)}
                                        onClick={() => {
                                            if(checkIfSubscribed(props) !== "SUBSCRIBED"){
                                                props.setSubscriptionModalOpen(true)
                                            }else{
                                                if(hasBroadcasterID(props)){
                                                    let broadcaster_id = props.contentList[0].broadcaster.id;
                                                    api.cancelSubscriptionAPI(props,null,broadcaster_id)
                                                }
                                            }
                                        }}
                                    />
                                    <ButtonWithImage
                                        color={"secondary"}
                                        text={checkIfFollowing(props)}
                                        src={getFollowingImageSrc(props)}
                                        onClick={() => {

                                            getData(LOGIN).then((data) => {
                                                if (!isEmpty(data)) {
                                                    if(checkIfFollowing(props) === "FOLLOW"){
                                                        //follow
                                                        props.followBroadcaster(
                                                            data.token,
                                                            data.api_token,
                                                            props.payload.summary.broadcaster.id
                                                        );
                                                    }else{
                                                        if(hasBroadcasterID(props)){
                                                            let broadcaster_id = props.contentList[0].broadcaster.id;
                                                            follow_unfollow_api.unFollowAPI(props,data,broadcaster_id)
                                                        }
                                                    }

                                                } else {
                                                    props.showLogin();
                                                }
                                            });
                                        }}
                                    />
                                    <ButtonWithImage
                                        color={"secondary"}
                                        text={"LIKE"}
                                        src={assets.broadcaster.profile.tip}
                                        onClick={props.showRequestTipModal}
                                    />
                                </Collapse>

                            </div>
                        </Container>
                    </div>
                }
                <ProfileTabComponent activeTab={props.activeTab} toggle={props.toggle} isBroadcastersOwnPage={props.isBroadcastersOwnPage}/>
            </Col>

            {props.showTipModalFlag && (
                <TipModal
                    showTipModalFlag={props.showTipModalFlag}
                    hideTipModal={props.hideTipModal}
                    balance={props.wallet_balance}
                    addBalance={props.showMoneyBloxModal}
                    tipRequest={props.tipRequest}
                    tipValue={props.tipValue}
                    lowBalanceAlert={props.lowBalanceAlert}
                />
            )}

            {
                props.tipMessage &&
                <TipResponseModal
                    showTipResponseModalFlag={props.showTipResponseModalFlag}
                    hideTipResponseModal={props.hideTipResponseModal}
                    tipMessage={props.tipMessage}
                />
            }
        </Collapse>
    );
}

export default BroadcasterProfileHeader;